// extracted by mini-css-extract-plugin
export default {"innerHeader":"InnerHeader_innerHeader__y6Dtc"};